<template>
    <div>
      <div class="fu">
        <h1 class="title">建立押金教程</h1>
        <p class="test">
           建立押金的方法如下。  
        </p>

        <iframe class="antenae" src="//player.bilibili.com/player.html?aid=436214800&bvid=BV1hj411T7s3&cid=988249259&page=1"
         scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
       </div>
    </div>
  </template>
  
  <script>
    export default {
            name:"BuildDeposit"
    }
  </script>
  
  <style scoped>
  @media(max-width:768px) {
    .test{
    font-size: 5vw;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
    .title{
    font-size: 6vw;
    color: #2c3e50;
  }
    .antenae{
    width: 90vw;
    height: 45vh;
    }
    .fu{
      width:100%;
      margin-left: 0px;
    }
  }
  
  @media (min-width: 768px){
    .test{
    font-size: 20px;
    border-left: 5px solid #42b983;
    background-color: #f3f5f7;
    padding-left:1vw;
    font-family: Helvetica Neue, SimSun, 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
  .title{
    font-size: 30px;
    color: #2c3e50;
  }
  .fu{
  margin-left: 13vw;
  margin-right: 7vw;
  }
  .antenae{
    width: 50vw;
    height: 60vh;
  }
  }
  </style>